// extracted by mini-css-extract-plugin
module.exports = {"textLink":"TextLink_textLink__1fHWJ","highlight":"TextLink_highlight__iJ4lx","hideUnderline":"TextLink_hideUnderline__1y5TT"};